// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import shield01Icon from "@/assets/icons/shield-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Shield01IconProps = Omit<IconProps, "name">;

export function Shield01Icon(props: Shield01IconProps): React.ReactNode {
  return <Icon name={shield01Icon} {...props} />;
}
